import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { fetchSeminarer, submitSeminarRegistration, fetchMySeminarRegistrations, cancelSeminarRegistration } from "../services/homeApi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "../components/Home/Footer";
import "./SeminarDetalj.css";

function SeminarDetalj() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user, email, name, age, role } = useAuth();
  const isMember = role === "member";

  const [seminar, setSeminar] = useState(null);
  const [existingReg, setExistingReg] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSeminarer()
      .then((list) => {
        setSeminar(list.find((s) => String(s.id) === String(id)) || null);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    if (user && seminar) {
      fetchMySeminarRegistrations()
        .then((regs) => setExistingReg(regs.find((r) => r.seminar_id === seminar.id) || null))
        .catch(console.error);
    }
  }, [user, seminar]);

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      await submitSeminarRegistration(seminar.id, {
        name: e.target.regName.value,
        email: e.target.regEmail.value,
        phone: e.target.phone.value,
        age_range: e.target.age.value,
      });
      toast.success("Påmelding sendt!");
      fetchMySeminarRegistrations().then((regs) => setExistingReg(regs.find((r) => r.seminar_id === seminar.id) || null));
    } catch (err) {
      toast.error(err.message || "Påmelding feilet. Prøv igjen.");
    }
  };

  const handleCancel = async () => {
    if (!existingReg) return;
    try {
      await cancelSeminarRegistration(existingReg.id);
      toast.info("Påmelding avbestilt");
      setExistingReg(null);
    } catch (err) {
      toast.error(err.message);
    }
  };

  if (loading) return (
    <div className="sd-page sd-center">
      <div className="spinner-border" style={{ color: "#d4af37" }} />
    </div>
  );

  if (!seminar) return (
    <div className="sd-page">
      <div className="sd-nav-strip">
        <div className="sd-container">
          <button className="sd-back-btn" onClick={() => navigate("/seminarer")}>← Tilbake</button>
        </div>
      </div>
      <div className="sd-center flex-grow-1">
        <p style={{ color: "#999" }}>Seminar ikke funnet.</p>
      </div>
      <Footer />
    </div>
  );

  const dateObj = seminar.date ? new Date(seminar.date + "T00:00:00") : null;
  const full = dateObj ? dateObj.toLocaleDateString("no-NO", { weekday: "long", day: "numeric", month: "long", year: "numeric" }) : null;

  return (
    <div className="sd-page">

      <div className="sd-nav-strip">
        <div className="sd-container">
          <button className="sd-back-btn" onClick={() => navigate("/seminarer")}>← Alle seminarer</button>
        </div>
      </div>

      <div className="sd-body">
        <div className="sd-container sd-narrow">

          <div className="sd-header">
            <span className="sd-eyebrow">Al-Yasin · Seminar</span>
            <h1 className="sd-title">{seminar.title}</h1>
            <div className="sd-meta">
              {full && <span className="sd-meta-item">📅 {full}</span>}
              {seminar.time && <span className="sd-meta-item">🕐 {seminar.time}</span>}
              {seminar.location && <span className="sd-meta-item">📍 {seminar.location}</span>}
              {seminar.speaker && <span className="sd-meta-item">🎤 {seminar.speaker}</span>}
            </div>
            {seminar.description && <p className="sd-desc">{seminar.description}</p>}
          </div>

          <div className="sd-divider" />

          <div className="sd-form-section">

            {existingReg ? (
              <>
                <div className="sd-section-title">Din påmelding</div>

                <div className="sd-booked-banner">
                  <span className="sd-booked-icon">✓</span>
                  <div>
                    <strong>Påmeldt</strong>
                    <p>Registrert som <strong>{existingReg.name}</strong></p>
                  </div>
                </div>

                <div className="sd-info-grid">
                  <div className="sd-info-item"><label>Navn</label><span>{existingReg.name}</span></div>
                  <div className="sd-info-item"><label>E-post</label><span>{existingReg.email}</span></div>
                  <div className="sd-info-item"><label>Telefon</label><span>{existingReg.phone || "–"}</span></div>
                  <div className="sd-info-item"><label>Alder</label><span>{existingReg.age_range || "–"}</span></div>
                  <div className="sd-info-item"><label>Påmeldt</label><span>{new Date(existingReg.created_at).toLocaleDateString("no-NO")}</span></div>
                </div>

                <div className="sd-actions">
                  <button className="sd-btn sd-btn-outline-red" onClick={handleCancel}>Avbestill påmelding</button>
                </div>
              </>

            ) : (
              <form onSubmit={handleRegister} noValidate>
                <div className="sd-section-title">Meld deg på</div>

                {isMember ? (
                  <div className="sd-notice sd-notice-green">
                    Logget inn som <strong>{name || user}</strong> — informasjonen din er forhåndsutfylt.
                  </div>
                ) : (
                  <div className="sd-notice sd-notice-blue">
                    Ikke medlem? <a href="/signup">Registrer deg</a> for automatisk utfylling neste gang.
                  </div>
                )}

                <div className="sd-field">
                  <label htmlFor="sd-name">Navn</label>
                  <input id="sd-name" name="regName" className="sd-input" placeholder="Ditt fulle navn"
                    defaultValue={name || user || ""} readOnly={isMember} autoComplete="name" required />
                </div>

                <div className="sd-field">
                  <label htmlFor="sd-email">E-post</label>
                  <input id="sd-email" type="email" name="regEmail" className="sd-input" placeholder="din@epost.no"
                    defaultValue={email || ""} readOnly={isMember} autoComplete="email" required />
                </div>

                <div className="sd-row">
                  <div className="sd-field">
                    <label htmlFor="sd-phone">Telefon <span style={{ fontWeight: 400, textTransform: "none", color: "#aaa" }}>(valgfritt)</span></label>
                    <input id="sd-phone" name="phone" type="tel" className="sd-input" placeholder="12345678"
                      autoComplete="tel" inputMode="numeric" maxLength={15}
                      onChange={(e) => { e.target.value = e.target.value.replace(/\D/g, ""); }} />
                  </div>
                  <div className="sd-field">
                    <label htmlFor="sd-age">Aldersgruppe</label>
                    <select id="sd-age" name="age" className="sd-input" defaultValue={age || ""} disabled={isMember}>
                      <option value="">Velg</option>
                      <option value="7-12">7–12</option>
                      <option value="13-18">13–18</option>
                      <option value="19-30">19–30</option>
                      <option value="30+">30+</option>
                    </select>
                    {isMember && <input type="hidden" name="age" value={age || ""} />}
                  </div>
                </div>

                <button type="submit" className="sd-btn sd-btn-primary sd-btn-full">
                  {isMember ? "Bekreft påmelding som medlem" : "Bekreft påmelding"}
                </button>
              </form>
            )}

          </div>
        </div>
      </div>

      <Footer />
      <ToastContainer position="top-center" autoClose={3500} hideProgressBar={false} theme="colored" />
    </div>
  );
}

export default SeminarDetalj;
